<template>
    <v-row>
        <v-col cols="12" md="3">
            <h4 class="my-text-black">Datos del profesional efector</h4>
        </v-col>
        <v-col cols="12" md="8">
            <p text-h5 class="font-weight-light">Busque por nombre o matrícula</p>
        </v-col>
    </v-row>
    <v-autocomplete
        required
        class="asterisco"
        :rules="obligatorio"
        label="Matricula - Apellido y Nombre"
        :items="profesionalesFacturador"
        return-object
        :item-title="itemTitlePrescriptor" 
        variant="solo"
        v-model="profesionalEfector"
        auto-select-first="true"
        no-data-text="No se encontraron resultados"
        :menu-props="{width: 200}"
        @update:modelValue="onProfesionalChange"
        :loading="cargandoEfector"
    ></v-autocomplete>
</template>
<style src="../assets/general.css"></style>
<script>
    import { obligatorio } from '@/_helpers/rules';
    import FacturadorService from '@/api/FacturadorService';

    const facturadorService = new FacturadorService();

    export default {
        data() {
            return {
                profesionalEfector: null,
                profesionalFacturador: null,
                profesionalesFacturador: [],
                cargandoEfector: false,
                obligatorio: obligatorio,
            }
        },
        async mounted(){
            await this.cargarEfectores();
            this.ordenarProfesionales();
        },
        methods: {
            onProfesionalChange(){
                this.$emit('profesional-seleccionado', this.profesionalEfector);
            },
            ordenarProfesionales(){
                return this.profesionalesFacturador.sort((a, b) => 
                    a.apellidos.toLocaleLowerCase().localeCompare(b.apellidos.toLocaleLowerCase())
                );
            },
            async cargarEfectores(){
                this.cargandoEfector = true;
                this.profesionalFacturador = this.$store.getters.getProfesional;
                const response = await facturadorService.getProfesionalesFacturador(this.$store.getters.getFacturador.id);
                if(response.status == 200){
                    this.profesionalesFacturador = response.data;
                }
                if(this.profesionalFacturador.matriculaProvincial != null){
                    this.profesionalEfector = this.profesionalFacturador;
                }
                else{
                    this.profesionalEfector = null;
                }
                this.cargandoEfector = false;
            },
            setearProfesional(profesional){
                this.profesionalEfector = profesional;
            },
            itemTitlePrescriptor(item) {
                if (!item) return '';
                if(item.matriculaProvincial){
                    return `${item.matriculaProvincial} - ${item.apellidos} ${item.nombres}`;
                }
                else{
                    return `${item.matriculaNacional} - ${item.apellidos} ${item.nombres}`;
                }
            },
        }
    }
</script>